import React, { FC } from 'react'

import { Txt, ProjectZeroIllustration } from 'src/components/atoms'

type Props = {
  className?: string
}

export const ProjectListZero: FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      <div className="tw-inline-flex tw-flex-col tw-items-center">
        <ProjectZeroIllustration />
        <Txt className="tw-mt-s3 tw-font-bold tw-text-roovPrimary-default">
          プロジェクトが存在しません
        </Txt>
      </div>
    </div>
  )
}
